import Vue from 'vue';
import './plugins/vuetify';
import App from './App.vue';
import router from './router';
import './registerServiceWorker';
import Vuex from 'vuex';
import store from './store';
import VueAnalytics from 'vue-analytics';
import colors from 'vuetify/es5/util/colors'
import filters from '@/filters';
import Vuetify from 'vuetify';

Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(VueAnalytics, { id: 'UA-141250831-1' });

Vue.filter('formatPercent', filters.formatPercent);
Vue.filter('formatNumber', filters.formatNumber);
Vue.filter('formatRank', filters.formatRank);
Vue.filter('formatDate', filters.formatDate);

Vue.use(Vuetify, {
  theme: {
    //primary: '#962D06', // #E53935
  }
});

new Vue({
  router,
  store: new Vuex.Store(store),
  render: h => h(App),
}).$mount('#app');
